define('uikit/modules/calendar',['require','exports','module','marionette','underscore','backbone','handlebars','moment','../mixins/component.mixin','../collections/container','../collections/grid','../elements/text','../elements/dropdown','../elements/button','../elements/input','./popup','./menu','../extra/scrollbar.calculate','../helper/dom','../templates','../channel','../extra/extend.util'],function(require, exports, module){
  var Mn             = require('marionette');
  var _              = require('underscore');
  var Backbone       = require('backbone');
  var Handlebars     = require('handlebars');
  var moment         = require('moment');
  var ComponentMixin = require('../mixins/component.mixin');
  var ContainerView  = require('../collections/container');
  var GridView       = require('../collections/grid');
  var TextView       = require('../elements/text');
  var DropdownView   = require('../elements/dropdown');
  var ButtonView     = require('../elements/button');
  var InputView      = require('../elements/input');
  var PopupView      = require('./popup');
  var MenuView       = require('./menu');
  var scrollbar      = require('../extra/scrollbar.calculate');
  var DOMHelper      = require('../helper/dom');
  var Templates      = require('../templates');
  var channel        = require('../channel');
  var ExtendUtil     = require('../extra/extend.util');

  var WEEK_TIME_INTERVAL_HEIGHT = 2;
  var WEEK_TIME_INTERVAL_LENGHT = 30;

  var DefaultCalendarAppointmentView = Mn.ItemView.extend(ComponentMixin).extend({

    className: 'item',

    template: Templates.UIKit['calendar.appointment'],

    options: {
      active     : false,
      disabled   : false,
      timeFormat : 'LT',
      eventDate  : null,
      text       : ''
    },

    format: {
      time: 'LT'
    },

    forceUpdate: { timeFormat: true, eventDate: true, text: true },

    attributes: {
      tabindex: '0'
    },

    events: {
      'keydown' : function(ev) { if (ev.keyCode == 13) { this.triggerMethod('press'); }}
    },

    triggers: {
      'click': { event: 'press', stopPropagation: true, preventDefault: false },
      'dblclick': { event: 'double:press', stopPropagation: true, preventDefault: false }
    },

    initialize: function() {
      ComponentMixin.initialize.apply(this, arguments);
      this.format = _.extend({}, this.format, this.options.format);
    },

    updateAttributes: function() {
      this
          .addClass('active', this.getBoolOption('active'))
          .addClass('disabled', this.getBoolOption('disabled'))
    },

    serializeData: function() {
      var data = ComponentMixin.serializeData.apply(this, arguments);

      data.time = moment(data.eventDate).format(this.format.time);

      return data;
    }

  });

  var MoreAppointmentsView = Mn.ItemView.extend({

    className: 'more',

    template: Templates.UIKit['calendar.cell.more'],

    events: {
      'keydown' : function(ev) { if (ev.keyCode == 13) { this.triggerMethod('press'); }}
    },

    triggers: {
      'click' : { event: 'press', stopPropagation: false, preventDefault: false }
    },

    onRender: function() {
      this.$el.find('i.icon').prop('tabindex', 0);
    }

  });

  var DefaultCalendarCellView = Mn.CompositeView.extend(ComponentMixin).extend({

    template: Templates.UIKit['calendar.cell'],

    className: 'day cell',

    childViewContainer: '.appointments',

    emptyView: false,

    getChildView: function(model) {
      if (model instanceof MoreAppointmentsModel) {
        return this.getOption('moreAppointmentsView');
      }
      return this.getOption('childView');
    },

    buildChildView: function(child, ChildViewClass, childViewOptions) {
      if (child instanceof MoreAppointmentsModel) {
        childViewOptions = Mn._getValue(this.getOption('moreAppointmentsViewOptions'), this, [child]);
      }
      ChildViewClass = ExtendUtil.extendClassBehaviors(ChildViewClass, childViewOptions);
      return Mn.CompositeView.prototype.buildChildView.call(this, child, ChildViewClass, childViewOptions);
    },

    options: {
      active        : false,
      appointment   : false,
      today         : false,
      other         : false,
      weekend       : false,
      moment        : null,
      hasMoreEvents : false
    },

    forceUpdate: { appointment: true, moment: true, hasMoreEvents: true },

    events: {
      'keydown' : function(ev) {
        if (ev.keyCode == 13) { this.triggerMethod('press'); }
      }
    },

    triggers: {
      'click': {
        preventDefault: false,
        stopPropagation: false,
        event: 'press'
      },
      'dblclick': {
        preventDefault: false,
        stopPropagation: false,
        event: 'double:press'
      },
      'mousedown': { event: 'before:press', stopPropagation: false, preventDefault: false}
    },

    childEvents: {
      'press': function(view, ev) {
        if (view.disabled) { return; }
        var moreAppointmentsViewClass = this.getOption('moreAppointmentsView');
        if (view instanceof MoreAppointmentsView) {
          this.trigger('more:press', view, view.model);
        } else {
          this.trigger('appointment:press', view, view.model);
        }
      },
      'double:press': function(view, ev) {
        if (!view.disabled) {
          this.trigger('appointment:double:press', view, view.model);
        }
      }
    },

    attributes: {
      tabindex: 0
    },

    initialize: function() {
      ComponentMixin.initialize.apply(this, arguments);
      this.collection = new Backbone.Collection();
    },

    updateAttributes: function() {
      this
          .addClass('other', this.getBoolOption('other'))
          .addClass('today', this.getBoolOption('today'))
          .addClass('weekend', this.getBoolOption('weekend'))
          .addClass('active', this.getBoolOption('active'));
    }

  });

  var DefaultCalendarHeaderCellView = Mn.ItemView.extend(ComponentMixin).extend({

    className: 'cell',

    template: function(data) {
      return Handlebars.escapeExpression(data.text);
    }

  });

  var CalendarPopupView = Mn.ItemView.extend(ComponentMixin).extend({

    template: Templates.UIKit['calendar.week.popup'],

    options: {

    },

    attributes: {
      // another stupid fix for firefox (i.e. stupidfox)
      style: 'width: 525px;'
    },

    initialize: function() {
      var self = this;

      ComponentMixin.initialize.apply(this, arguments);

      function scrollToActive() {
        var view = this;
        self.scrollToActiveItem(view);
      };

      this.monthGrid = new MenuView({ secondary: true, attributes: { style: 'max-height: 200px; overflow-y: auto;' } })
          .on('change:visible', scrollToActive);
      this.yearGrid  = new MenuView({ secondary: true, visible: false, attributes: { style: 'max-height: 200px; overflow-y: auto;' } })
          .on('change:visible', scrollToActive);

      this.monthButton = new ButtonView({ text: "Months", active: true })
          .on('press', function() {
            this.monthButton.active = this.monthGrid.visible = true;
            this.yearButton.active  = this.yearGrid.visible = false;
          }, this);
      this.yearButton = new ButtonView({ text: "Years" })
          .on('press', function() {
            this.monthButton.active = this.monthGrid.visible = false;
            this.yearButton.active  = this.yearGrid.visible = true;
          }, this);

      this.yearButton.$el.css('margin-left', 0);

      this.once('before:render', function() {
        this.populateMonthGrid();
        this.populateYearGrid();
        this.setupCalendar();
      }, this);
    },

    scrollToActiveItem: function(view) {
      if (view.visible) {
        var views = view.toArray();
        for (var i = 0, len = views.length, child; i < len; i++) {
          child = views[i];
          if (child.active) {
            view.$el.scrollTop(view.$el.scrollTop() - view.$el.offset().top + child.$el.offset().top);
          }
        }
      }
    },

    updateYearGrid: function() {
      var calendar = this.getOption("calendar");
      this.yearGrid
        .each(function(view) {
          if (Number(view.text) == calendar.year) {
            view.active = true;
          } else {
            view.active = false;
          }
        });
    },

    updateMonthGrid: function() {
      var calendar = this.getOption("calendar");
      this.monthGrid
          .each(function(view, index) {
            if (index == calendar.month) {
              view.active = true;
            } else {
              view.active = false;
            }
          });
    },

    updateGrids: function() {
      this.updateYearGrid();
      this.updateMonthGrid();
    },

    setupCalendar: function() {
      var calendar = this.getOption('calendar');

      this
          .listenTo(calendar, 'change:year change:month', _.debounce(this.updateGrids));

      this.updateGrids();
    },

    populateMonthGrid: function() {
      var months = moment.monthsShort();
      for (var i = 0, len = months.length, month; i < len; i++) {
        this.monthGrid.add(this.createMonthItem(i));
      }
    },

    createMonthItem: function(index) {
      var month = moment.monthsShort(index);
      return new MenuView.Item({ text: month, link: true, attributes: { style: 'width: 25%; margin: 0; padding: 1em; text-align: center;'} })
          .on('press', function() {
            this.triggerMethod('month:press', index, month);
          }, this)
    },

    onMonthPress: function(monthIndex, monthText) {
      var calendar = this.getOption('calendar');
      calendar._setOption('month', monthIndex, { internal: true });
    },

    populateYearGrid: function() {
      var currentYear = moment().year();
      for (var i = currentYear-20, len = currentYear+20; i < len; i++) {
        this.yearGrid.add(this.createYearItem(i));
      }
    },

    createYearItem: function(year) {
      return new MenuView.Item({ text: String(year), link: true, attributes: { style: 'width: 25%; margin: 0; padding: 1em; text-align: center;'} })
          .on('press', function() {
            this.triggerMethod('year:press', year);
          }, this)
    },

    onYearPress: function(year) {
      var calendar = this.getOption('calendar');
      calendar._setOption('year', year, { internal: true })
    }

  });

  var CalendarWeekPopupView = CalendarPopupView.extend({

    initialize: function() {
      CalendarPopupView.prototype.initialize.apply(this, arguments);
      this.monthButton.text = 'Weeks';
    },

    updateGrids: function() {
      this.updateYearGrid();
      this.updateWeekGrid();
    },

    setupCalendar: function() {
      var calendar = this.getOption('calendar');

      this
          .listenTo(calendar, 'change:date', _.debounce(this.updateGrids));

      this.updateGrids();
    },

    updateWeekGrid: function() {
      var calendar  = this.getOption('calendar'),
          year      = moment(calendar.date).year(),
          m         = moment([year, 0, 1]).startOf('week'),
          self      = this,
          toDestroy = this.monthGrid.empty();


      _.defer(function() {
        _.invoke(toDestroy, 'destroy');
      });

      while (m.year() <= year) {
        this.monthGrid.add(this.createWeekItem(m));
        m = m.clone().add(1, 'week');
      }
    },

    onShow: function() {
      var self = this;
      setTimeout(function() {
        self.scrollToActiveItem(self.monthGrid);
        self.scrollToActiveItem(self.yearGrid);
      }, 500);
    },

    createWeekItem: function(weekMoment) {
      var endOfWeek     =  weekMoment.clone().add(6, 'days').endOf('day'),
          calendar      = this.getOption('calendar'),
          currentMoment = moment(calendar.date),
          text          = weekMoment.format('MMM D') + '-' + endOfWeek.format('MMM DD'),
          active        = currentMoment.isSame(weekMoment, 'day')
                          || currentMoment.isSame(endOfWeek, 'day')
                          || currentMoment.isBetween(weekMoment, endOfWeek, 'day');

      return new MenuView.Item({ text: text, link: true, active: active, attributes: { style: 'width: 25%; margin: 0; padding: 1em; text-align: center;'} })
          .on('press', function() {
            this.triggerMethod('week:press', weekMoment);
          }, this);
    },

    onWeekPress: function(weekMoment) {
      var calendar = this.getOption('calendar');
      calendar._setOption('date', +weekMoment, { internal: true });
    },

    onYearPress: function(year) {
      var calendar = this.getOption('calendar'),
          date     = moment(calendar.date);

      calendar._setOption('date', +moment([year, date.month(), 1]), { internal: true });
    },

    populateMonthGrid: function() {
      // do nothing
    }

  });

  var DateDisplayView = Mn.ItemView.extend(ComponentMixin).extend({

    template: Templates.UIKit['calendar.date.display'],

    className: 'date display',

    options: {
      disabled: false,
      year  : null,
      month : null,
      date  : null
    },

    forceUpdate: { year: true, month: true, date: true },

    format: {
      month: 'MMMM',
      year: 'YYYY'
    },

    attributes: {
      style: 'cursor: pointer;'
    },

    events: {
      'keydown' : function(ev) {
        var keyCode = ev.keyCode;

        if (keyCode == 13) {
          this.triggerMethod('press');

        } else if (keyCode == 9) {
          var f = DOMHelper.focusable(this.popup.$el);

          // If the popup is visible,
          // tab into the next tabbable item inside the popup
          if (this.popup.visible) {
            ev.preventDefault();
            f.eq(0).focus();
          }
        } else if (keyCode == 27 && this.popup.visible) {
          this.popup.hide();
        }
      }
    },

    triggers: {
      'click': {
        event: 'press',
        preventDefault: false,
        stopPropagation: false
      }
    },

    initialize: function() {
      ComponentMixin.initialize.apply(this, arguments);
      this.format = _.extend({}, this.format, this.options.format);
      this.once('before:render', this.setupCalendar);

      var popup = this.popup = new PopupView({
            showOn    : 'click',
            exclusive : false,
            position  : 'bottom center',
            width     : PopupView.VERY_WIDE
          })
          .attach(this);

      this.popup.content = null;

      this
        .on('destroy', function() {
          this.popup.destroy();
        });

    },

    isCalendarWeek: function() {
      return (this.getOption('calendar') instanceof CalendarWeek);
    },

    setupCalendar: function() {
      var calendar  = this.getOption('calendar');

      if (!calendar) { return; }

      if (!this.popup.content) {
        if (this.isCalendarWeek()) {
          this.popup.content = new CalendarWeekPopupView();
        } else {
          this.popup.content = new CalendarPopupView();
        }
      }

      if (this.popup.content) {
        // copy over the calendar
        this.popup.content.options.calendar = calendar;
      }

      function transferDates() {
        if (this.isCalendarWeek()) {
          this.date  = calendar.date;
        } else {
          this.year  = calendar.year;
          this.month = calendar.month;
        }
      };

      this.listenTo(calendar, 'change:date change:month change:year', transferDates);

      transferDates.call(this);
    },

    getMoment: function() {
      if (this.date) {
        return moment(this.date);
      } else {
        return moment([this.year, this.month, 1]);
      }
    },

    updateAttributes: function() {
      if (this.disabled) {
        this.$el.removeAttr('tabindex');
        this.$el.css('pointer-events', 'none');
      } else {
        this.$el.prop('tabindex', 0);
        this.$el.css('pointer-events', '');
      }
    },

    serializeData: function() {
      var data = ComponentMixin.serializeData.apply(this, arguments),
          m    = this.getMoment();

      if (this.isCalendarWeek()) {
        m.startOf('week');
      }

      data.year  = m.format(this.format.year);
      data.month = m.format(this.format.month);

      return data;
    }

  });


  var BaseCalendarControlsView = Mn.ItemView.extend(ComponentMixin).extend({

    className: 'controls default',

    template: Templates.UIKit['calendar.default.controls'],

    options: {
      centered  : false,
      size      : '',
      fluid     : false,
    },

    events: {
      'keydown .previous' : function(ev) { if (ev.keyCode == 13) { this.triggerMethod('previous'); }},
      'keydown .next' : function(ev) { if (ev.keyCode == 13) { this.triggerMethod('next'); }}
    },

    triggers: {
      'click .previous': {
        event: 'previous',
        stopPropagation: false,
        preventDefault: false
      },
      'click .next': {
        event: 'next',
        stopPropagation: false,
        preventDefault: false
      }
    },

    ui: {
      leftWrapper: '.left.wrapper',
      rightWrapper: '.right.wrapper'
    },

    initialize: function() {
      ComponentMixin.initialize.apply(this, arguments);
      this.content = new ContainerView();
      this.left    = new ContainerView();
      this.right   = new ContainerView();

      this.on('before:render', function() {
        this.content.each(function(view) {
          view.options.calendar = this.getOption('calendar');
        }, this)
      }, this)
    },

    updateAttributes: function() {
      this
          .addClass('fluid', this.getBoolOption('fluid'))
          .addClass(this.getOption('size'), this.getBoolOption('size'))
          .addClass('centered', this.getBoolOption('centered'))
    }

  });

  var DefaultCalendarControlsView = BaseCalendarControlsView.extend({

    initialize: function() {
      BaseCalendarControlsView.prototype.initialize.apply(this, arguments);
      this.text = new DateDisplayView({ format: this.format });
      this.content
          .add(this.text)
    }

  });


  var CalendarWeekAppointment = Mn.ItemView.extend(ComponentMixin).extend({

    className: 'appointment',

    template: Templates.UIKit['calendar.week.appointment'],

    options: {
      startTime  : 0,
      disabled   : false,
      endTime    : 0,
      duration   : 0,
      active     : false,
      overlap    : null,
      text       : ''
    },

    forceUpdate: { startTime: true, endTime: true, duration: true, text: true },

    format: {
      time: 'LT'
    },

    attributes: {
      'tabindex': 0
    },

    events: {
      'keydown' : function(ev) {
        if (ev.keyCode == 13) {
          this._buildViewTrigger('press').call(this, ev);
        }}
    },

    triggers: {
      'click'    : { event: 'press', stopPropagation: false, preventDefault: false },
      'dblclick' : { event: 'double:press', stopPropagation: false, preventDefault: false }
    },

    initialize: function() {
      this.on('change:endTime change:duration', this.calculateTime, this);
      ComponentMixin.initialize.apply(this, arguments);
      this.format = _.extend({}, this.format, this.options.format);
      this.calculateTime();
    },

    onFirstRender: function() {
      this.on('change:startTime change:duration', this.applyPosition, this);
      this.applyPosition();
    },

    calculateTime: function() {
      if (this.startTime) {
        if (this.bindings.endTime && this.endTime) {
          this.duration = moment(this.endTime).diff(this.startTime, 'minutes');
        } else if (this.bindings.duration && this.duration) {
          this.endTime = moment(this.startTime).add(moment.duration(this.duration, 'minutes')).valueOf();
        }
      }
    },

    serializeData: function() {
      var data = ComponentMixin.serializeData.apply(this, data);
      data.time = moment(this.startTime).format(this.format.time);
      return data;
    },

    applyPosition: function() {
      var startTime = moment(this.startTime),
          endTime   = moment(this.endTime),
          minutes   = (startTime.hours() * 60) + startTime.minutes(),
          top       = ((minutes/WEEK_TIME_INTERVAL_LENGHT)) * WEEK_TIME_INTERVAL_HEIGHT,
          height    = (this.duration/WEEK_TIME_INTERVAL_LENGHT) * WEEK_TIME_INTERVAL_HEIGHT;

      this.$el.css('top', top + 'em').css('height', height + 'em');
    },

    updateAttributes: function() {
      this
          .addClass('active', this.getBoolOption('active'))
          .addClass('overlap ' + this.getOption('overlap'), this.getBoolOption('overlap'))
          .addClass('disabled', this.getBoolOption('disabled'))
    }

  });

  var CalendarWeekDayCell = Mn.ItemView.extend({

    className: 'cell',

    tagName: 'th',

    template: Templates.UIKit['calendar.week.day.cell']

  });

  var CalendarWeekDayGrid = Mn.CompositeView.extend({

    tagName: 'td',

    childViewContainer: '.list',

    emptyView: false,

    template: Templates.UIKit['calendar.week.appointment.list']

  });

  var EmptyCollectionView = Mn.CollectionView.extend({

    emptyView: false

  });

  var CalendarWeek = Mn.ItemView.extend(ComponentMixin).extend({

    className: 'ui week',

    template: Templates.UIKit['calendar.week'],

    ui: {
      appointments  : '.appointments',
      header        : '.header',
      wrapper       : '.wrapper',
      scroller      : '.scroller',
      headerWrapper : '.calendarheader'
    },

    emptyView: false,

    appointmentView: CalendarWeekAppointment,

    appointmentGridOptions: function() {
      var self = this;
      return {
        childView: this.getOption('appointmentView'),
        childViewOptions: function() {
          var appointmentGrid = this;
          return self.appointmentViewOptions.apply(self, [appointmentGrid].concat(_.toArray(arguments)));
        },
        collection: new Backbone.Collection()
      }
    },

    appointmentViewOptions: function(grid, model) {
      return _.extend({
        bindings : _.extend({}, this.childBindings),
        overlap  : this.processAppointmentOverlap(grid.collection, model)
      });
    },

    options: {
      // year          : new Date().getFullYear(),
      // month         : new Date().getMonth(),
      date          : new Date().getTime(),
      week          : null,
      value         : null,
      fluid         : true,
      verticalFluid : true,
      businessStart : 10,
      businessEnd   : 22,
      aligned       : 'right',
      borderless    : false,
      collection    : null
    },

    forceUpdate: {
      fluid: true,
      businessStart: true,
      businessEnd: true,
      aligned: true
    },

    bindings: {
      // startTime: 'startTime',
      // endTime: 'endTime'
      // text: 'text'
    },

    format: {
      day: 'ddd D',
      time: 'LT',
      month: 'MMMM D'
    },

    initialize: function() {
      var self = this;
      ComponentMixin.initialize.apply(this, arguments);
      this.dayHeader = new EmptyCollectionView({ childView: CalendarWeekDayCell });
      this.appointmentGrid = new EmptyCollectionView({ childView: CalendarWeekDayGrid, childViewOptions: _.bind(this.appointmentGridOptions, this) });
      this.appointmentGrid.on('childview:add:child', function(grid, view) {
        this.triggerMethod('add:appointment', view);
      }, this);
      this.format = _.extend({}, this.format, this.options.format);
      this.dayHeader.collection = this.appointmentGrid.collection = this.dayCollection = new Backbone.Collection();
      if (!this.controls && this.controls !== false) {
        this.controls = new DefaultCalendarControlsView({ format: this.format });
      }
      this.listenTo(this, 'change:date', function() {
        if (this.date != null) {
          this.controls.date = this.date;
        }
      });

      function windowResize() {
        self.triggerMethod('window:resize');
      }

      windowResize = _.debounce(windowResize, 10);

      $(window).on('resize', windowResize);

      this
          .on('destroy', function() {
            $(window).off('resize', windowResize);
          })
          .on('change:visible', _.debounce(function() {
            if (this.visible) {
              this.calculateContentHeight();
              this.updateContentScroll();
            }
          }));
    },

    onDomRefresh: function() {
      // this call when the view is both rendered and shown
      // if the view is not visible when it is both of these
      // then it will not work.  You will have to manually
      // call "show" on this view when it is in fact visible
      var self = this;
      _.defer(function() {
        self.calculateContentHeight();
        self.updateContentScroll();
      });
    },

    onWindowResize: function() {
      this.calculateContentHeight();
      this.updateContentScroll();
    },

    calculateContentHeight: function() {
      this.ui.scroller.height('auto');
      this.ui.scroller.height(this.ui.wrapper.height() - this.ui.headerWrapper.height());
    },

    updateContentScroll: function() {
      var self = this;
      _.defer(function() {
        self.ui.scroller.scrollTop(475);
      })
    },

    updateAttributes: function() {
      this
          .addClass('fluid', this.getBoolOption('fluid') && !this.getBoolOption('verticalFluid'))
          .addClass('vertical fluid', this.getBoolOption('verticalFluid'))
          .addClass('borderless', this.getBoolOption('borderless'))
          .addClass(this.getOption('aligned') + ' aligned', this.getBoolOption('aligned'))
    },

    onAddAppointment: function(view) {
      view
      .on('press', function(ev) {
        if (!view.disabled) {
          this.triggerMethod('appointment:press', ev.view, ev.model);
        }
      }, this)
      .on('double:press', function(ev) {
        if (!view.disabled) {
          this.triggerMethod('appointment:double:press', ev.view, ev.model);
        }
      }, this)
    },

    onAppointmentPress: function(view) {
      if (view.disabled) { return; }
      this.value = view.model;
    },

    onChangeValue: function() {
      var value = this.value;
      this.appointmentGrid.children.each(function(grid) {
        grid.children.each(function(view) {
          if (view.model === value) {
            view.active = true;
          } else {
            view.active = false;
          }
        }, this);
      }, this)
    },

    onRender: function() {
      this.dayHeader.setElement(this.ui.header).render();
      this.appointmentGrid.setElement(this.ui.appointments).render();
    },

    onFirstRender: function() {
      if (this.controls) {
        this.controls.options.calendar = this;
        this.controls.format.month = this.format.month;
      }
      this.on('change:date', function() {
        this.dayCollection.set(this.generateDays());
        this.processCollection();
      }, this);
      this.on('controls:previous', function() {
        this.subtractFromDate(7, 'days');
      }, this);
      this.on('controls:next', function() {
        this.addToDate(7, 'days');
      });
      this.dayCollection.set(this.generateDays());
      this.on('change:collection', this._setupCollection, this);
      this._setupCollection();
    },


    addToDate: function() {
      var m = moment(this.date);
      var newDate = m.add.apply(m, arguments);
      this.date = +newDate;
      return this;
    },

    subtractFromDate: function() {
      var m = moment(this.date);
      var newDate = m.subtract.apply(m, arguments);
      this.date = +newDate;
      return this;
    },

    _setupCollection: function() {
      if (this.collection) {
        this.listenTo(this.collection, 'add remove sort reset', _.debounce(this.processCollection, 1));
        this.processCollection();
      }
    },

    hours: function() {
      var hours = [],
          today = new Date(),
          major = false,
          mdate = moment(today).startOf('day');

      while (mdate.isSame(today, 'day')) {
        mdate = mdate.add(1, 'hour');
        hours.push({
          date         : mdate.toDate(),
          businessHour : mdate.toDate().getHours() >= this.getOption('businessStart') && mdate.toDate().getHours() < this.getOption('businessEnd'),
          text         : mdate.format(this.format.time)
        });
      }

      return hours;
    },

    processCollection: function() {
      var items = [];

      if (this.collection && this.childBindings.startTime && this.childBindings.endTime) {
        items = this.collection.map(function(model) {
          var startTime = moment(model.get(this.childBindings.startTime));
          return {
            startTime : startTime,
            model     : model
          };
        }, this);
      }

      items = _.sortBy(items, function(item) {
        return item.startTime.toDate().getTime();
      });

      this.appointmentGrid.children.each(function(view) {
        var model        = view.model,
            date         = view.model.get('date'),
            endOfDay     = moment(date).endOf('day'),
            appointments = [];

        for (var j = 0, len = items.length, item; j < len; j++) {
          item = items[j];
          if (item.startTime.isSame(date, 'day')) {
            appointments.push(item.model);
          } else if (item.startTime.isAfter(endOfDay, 'hour')) {
            break;
          }
        }

        view.collection.set(appointments);
      }, this);

    },

    processAppointmentOverlap: function(collection, model) {
      var bindings   = this.childBindings,
          startTime  = moment(model.get(bindings.startTime)),
          endTime    = moment(model.get(bindings.endTime)),
          cStartTime = null,
          cEndTime   = null,
          overlap    = null;

      // the purpose of this function is to determine how appointsments overlap which each other
      // if we return 'pre' then the appointment should take up 50% and be on the left
      // if we return 'post' then the appointment should take up 50% and be on the right

      for (var i = 0, len = collection.length, m; i < len; i++) {
        m = collection.at(i);
        if (m === model) { continue; }
        cStartTime = moment(m.get(bindings.startTime));
        cEndTime = moment(m.get(bindings.endTime));
        if (cStartTime.isBetween(startTime, endTime) || (startTime.isSame(cStartTime, 'minute') && i < collection.indexOf(model))) {
          overlap = 'pre';
          break;
        } else if (startTime.isBetween(cStartTime, cEndTime) || (startTime.isSame(cStartTime, 'minute') && i > collection.indexOf(model))) {
          overlap = 'post';
          break;
        }
      }

      return overlap;
    },

    generateDays: function() {
      var weekdays    = moment.weekdays(),
          startOfWeek = moment(this.date).startOf('week').toDate(),
          days        = [];

      for (var i = 0, day, endOfDay, len = weekdays.length; i < len; i++) {
        day = {
          date: new Date(startOfWeek.getFullYear(), startOfWeek.getMonth(), startOfWeek.getDate() + i)
        };

        day.id   = day.date.getTime();
        day.text = moment(day.date).format(this.format.day);

        days.push(day);
      }

      return days;
    },

    serializeData: function() {
      var data     = ComponentMixin.serializeData.apply(this, arguments);

      data.weekdays = moment.weekdays();
      data.hours = this.hours();
      data.scrollbarWidth = scrollbar.width();

      return data;
    },

    onDestroy: function() {
      this.dayHeader.destroy();
      this.appointmentGrid.destroy();
    }

  });

  var MoreAppointmentsModel = Backbone.Model.extend({

  });

  var Calendar = Mn.ItemView.extend(ComponentMixin).extend({

    className: 'ui calendar',

    options: {
      year            : new Date().getFullYear(),
      month           : new Date().getMonth(),
      selectable      : false,
      fluid           : false,
      verticalFluid   : false,
      celled          : false,
      innercelled     : false,
      value           : null,
      selectedDate    : null,
      start           : null,
      appointmentDot  : false,
      appointmentList : false,
      size            : '',
      aligned         : '',
      maxAppointments : 3,
      collection      : null,
      end             : null
    },

    forceUpdate: {
      appointmentDot: true,
      appointmentList: true,
      maxAppointments: true
    },

    format: {
      date : 'DD',
      day  : 'ddd',
      year : 'YYYY'
    },

    template: Templates.UIKit['calendar'],

    childView: DefaultCalendarCellView,

    appointmentView: DefaultCalendarAppointmentView,

    moreAppointmentsView: MoreAppointmentsView,

    childEvents: {
      'controls:next': function() {
        this.month++;
      },
      'controls:previous': function() {
        this.month--;
      }
    },

    initialize: function() {
      ComponentMixin.initialize.apply(this, arguments);
      this.content = new ContainerView({ className: 'content' });
      this.format = _.extend({}, this.format, this.options.format);
      if (!this.controls && this.controls !== false) {
        this.controls = new DefaultCalendarControlsView(_.extend({}, this.getOption('controlViewOptions')));
      }
    },

    onFirstRender: function() {
      this.on('change:collection', this._setupCollection, this);
      this._setupCollection();

      if (this.controls) {
        this.controls.options.calendar = this;
      }
      this
          .on('change:year change:month', function(self, value, previous, options) {
            if (_.result(options, 'internal')) { return; }
            this.recalculateYearAndMonth();
          })
          .on('change:year change:month', _.debounce(function() {
            this._updateContent();
          }))
      this.recalculateYearAndMonth();
      this._updateContent();
    },

    _setupCollection: function() {
      if (this.collection) {
        this.listenTo(this.collection, 'add remove reset update', _.debounce(this.processCollection));
        this.processCollection();
      }
    },

    processCollection: function() {
      var collection = this.collection;

      if (!this.appointmentViewOptions) { return; }

      var dates = collection.map(function(model, index) {
        var appointmentViewOptions = Mn._getValue(this.appointmentViewOptions || {}, this, [model]) || {};
        var bindings = appointmentViewOptions.bindings || {};
        var eventDate = bindings.eventDate;
        return {
          date: eventDate ? +moment(model.get(eventDate)) : null,
          model: model
        };
      }, this);

      dates = _.sortBy(dates, function(d) {
        return d.date;
      });

      this.each(function(view, m) {
        view.appointments = view.appointments || new Backbone.Collection();

        var found = [];
        while (dates.length > 0 && m.isAfter(dates[0].date, 'day')) {
          dates.shift();
        }

        while (dates.length > 0 && m.isSame(new Date(dates[0].date), 'day')) {
          found.push(dates[0].model);
          dates.shift();
        }

        view.appointments.set(found);

        if (this.getOption('appointmentList')) {
          var maxAppointments = Mn._getValue(this.getOption('maxAppointments'), this);

          view.collection.set(found.slice(0, maxAppointments));

          if (view.collection.length < found.length) {
            var extraAppointments = found.slice(maxAppointments);
            view.collection.push(new MoreAppointmentsModel({
              extraAppointmentCount: extraAppointments.length,
              appointmentCollection: new Backbone.Collection(view.appointments.models),
              extraAppointmentCollection: new Backbone.Collection(extraAppointments),
              eventDate: +m
            }));
            view.hasMoreEvents = true;
          }

        }

        if (_.isEmpty(found)) {
          view.appointment = false;
        } else {
          if (this.getOption('appointmentDot')) {
            view.appointment = true;
          }
        }

      });
    },

    isDayVisible: function(date) {
      var m = moment(date),
          found = false;

      this.each(function(view, dayMoment) {
        if (dayMoment.isSame(m, 'day')) {
          found = true;
        }
      });

      return found;
    },

    onDayPress: function(cell) {
      this._activeCell = cell;
      if (this._activeAppointment) {
        this._activeAppointment.active = false;
        this._activeAppointment = null;
      }
      cell.active = true;
      this.value = cell.moment;
    },

    onAppointmentPress: function(appointment, model) {
      if (appointment.disabled) { return; }

      if (this._activeAppointment && this._activeAppointment !== appointment) {
        this._activeAppointment.active = false;
      }
      this._activeAppointment = appointment;
      this.selectedAppointment = model;
      if (this._activeCell) {
        this._activeCell.active = false;
      }
      appointment.active = true;
      this.value = moment(appointment.eventDate).startOf('day');
    },

    onChangeSelectedDate: function() {
      if (!this._fromInternal) {
        if (this.selectedDate) {
          this.value = moment(this.selectedDate).startOf('day');
        } else {
          this.value = null;
        }
      }
      this._fromInternal = false;
    },

    onChangeValue: function(self, value, oldValue) {
      this._fromInternal = true;
      if (this.value) {
        this.selectedDate = +this.value;
      } else {
        this.selectedDate = null;
      }

      if (this._activeAppointment) { return; }

      this.each(function(view, m) {
        if (m.isSame(value, 'day')) {
          view.active = true;
        } else {
          view.active = false;
        }
      });
    },

    recalculateYearAndMonth: function() {
      var date = new Date(this.year, this.month, 1);

      if (!moment(date).isValid()) {
        return;
      }
      // sometimes the month can be set to something higher
      // than the ammount of months in the year
      // this means we need to update the year
      // and the month to their correct values
      this._setOption('year', date.getFullYear(), { internal: true });
      this._setOption('month', date.getMonth(), { internal: true });
    },

    each: function(fn, context) {
      var self = this;
      this.content.each(function(container) {
        container.each(function(view) {
          if (view instanceof DefaultCalendarHeaderCellView) { return; }
          fn && fn.call(context || self, view, view.moment);
        });
      });
      return this;
    },

    updateAttributes: function() {
      this
          .addClass('selectable', this.getBoolOption('selectable'))
          .addClass('fluid', this.getBoolOption('fluid') || this.getOption('verticalFluid'))
          .addClass('vertical', this.getBoolOption('verticalFluid'))
          .addClass('celled', this.getBoolOption('celled') && !this.getBoolOption('innercelled'))
          .addClass('innercelled', this.getBoolOption('innercelled'))
          .addClass(this.getOption('aligned') + ' aligned', this.getBoolOption('aligned'))
          .addClass(this.getOption('size'), this.getBoolOption('size'))
          .addClass('controls', this.getBoolOption('controls'))
    },

    _updateContent: function() {
      var container = null,
          self      = this;

      var oldViews = this.content.empty();

      _.defer(function() {
        // wait till next tick to destroy children
        // so that rendering is not blocked
        _.invoke(oldViews, 'destroy');
      })

      // start by adding the header
      container = new ContainerView({ destroyChildren: true, className: 'week header' });
      this.content.add(container);

      for (var i = 0, days = moment.weekdaysShort(); i < days.length; ++i) {
        container.add(this.createHeaderCell(days[i], i));
      };

      var days = this.days();

      this._setOption('start', +moment(days[0]), { internal: true });
      this._setOption('end', +moment(_.last(days)), { internal: true });

      _.each(days, function(day) {
        var dayView = this.createDayCell(day);
        this.triggerMethod('before:add:day', this, dayView);
        if (day.getDay() == 0) {
          container = new ContainerView({ destroyChildren: true, className: 'week' });
          this.content.add(container);
        }
        container.add(dayView);
        dayView.on('before:press', function() {
          this.triggerMethod.apply(this, ['day:before:press', dayView].concat(_.toArray(arguments)));
        }, this);
        dayView.on('press', function() {
          this.triggerMethod.apply(this, ['day:press', dayView].concat(_.toArray(arguments)));
        }, this);
        dayView.on('double:press', function() {
          this.triggerMethod.apply(this, ['day:double:press', dayView].concat(_.toArray(arguments)));
        }, this);
        dayView.on('appointment:press', function() {
          this.triggerMethod.apply(this, ['appointment:press'].concat(_.toArray(arguments)));
        }, this);
        dayView.on('appointment:double:press', function() {
          this.triggerMethod.apply(this, ['appointment:double:press'].concat(_.toArray(arguments)));
        }, this);
        dayView.on('more:press', function() {
          this.triggerMethod.apply(this, ['more:press'].concat(_.toArray(arguments)));
        }, this);
        this.triggerMethod('add:day', this, dayView);
      }, this);

      if (this.collection) {
        this.processCollection();
      }
    },

    createDayCell: function(date) {
      var today   = moment(date).isSame(new Date(), 'day'),
          mdate   = moment(date),
          current = new Date(this.year, this.month);

      return this.buildComponent(
        _.extend(
          {
            type: this.getOption('childView') || DefaultCalendarCellView,
            childView            : this.getOption('appointmentView'),
            childViewOptions     : this.getOption('appointmentViewOptions'),
            moreAppointmentsView : this.getOption('moreAppointmentsView'),
            active               : mdate.isSame(this.value, 'day'),
            moment               : mdate,
            date                 : mdate.format(this.format.date),
            day                  : mdate.format(this.format.day),
            previousMonth        : mdate.isBefore(current, 'month'),
            nextMonth            : mdate.isAfter(current, 'month'),
            other                : !mdate.isSame(current, 'month'),
            // determine if the date is a weekend day
            weekend              : mdate.day() == 0 || mdate.day() == 6,
            today                : today,
            bindings             : this.childBindings,
            year                 : mdate.format(this.format.year)
          },
          Mn._getValue(this.getOption('childViewOptions'), this)
        )
      );
    },

    createHeaderCell: function(text, index) {
      return new DefaultCalendarHeaderCellView({ text: text });
    },

    days: function() {
      var date      = new Date(this.year, this.month, 1),
          days      = [];

      if (!moment(date).isValid()) {
        return days;
      }

      if (date.getDay() == 0) {
        for (var i = -6; i <= 0; ++i) {
          days.push(new Date(this.year, this.month, i));
        }
      }

      for (var dayOfWeek = date.getDay(), i = 0; i < dayOfWeek; ++i) {
        days.push(new Date(this.year, this.month, (i-dayOfWeek)+1));
      }


      while (date.getMonth() == this.month) {
        days.push(date);
        date = new Date(this.year, this.month, date.getDate()+1);
      }

      date = _.last(days);

      for (var count = 6-date.getDay(), i = 0; i < count; ++i) {
        days.push(new Date(this.year, this.month, date.getDate() + i + 1));
      }

      if (days.length/7 < 6) {
        date = _.last(days);
        for (var i = 0; i < 7; ++i) {
          days.push(new Date(date.getFullYear(), date.getMonth(), date.getDate() + i + 1));
        }
      }

      return days;
    }

  },
  {
    findDateValue: function(yearValue, monthValue, date) {
      var month     = moment([yearValue, monthValue, 1]),
          dateValue = null,
          m         = moment(date);

      if (m.isBefore(month, 'month')) {
        dateValue = m.diff(month, 'days') + 1;
      } else if (m.isAfter(month, 'month')) {
        dateValue = 0;
        while (m.isAfter(month, 'month')) {
          dateValue += moment([month.year(), month.month(), 1]).endOf('month').date();
          month = month.add(1, 'month');
        }
        dateValue += m.date();
      } else {
      // if we are the same month just copy the date over
        dateValue = m.date();
      }
      return dateValue;
    }
  });

  Calendar.DefaultHeaderView      = DefaultCalendarHeaderCellView;
  Calendar.DefaultCellView        = DefaultCalendarCellView;
  Calendar.DefaultControlsView    = DefaultCalendarControlsView;
  // Calendar.DropdownControlsView   = DropdownCalendarControlsView;
  Calendar.DefaultAppointmentView = DefaultCalendarAppointmentView;
  Calendar.DateDisplay        = DateDisplayView;
  Calendar.Week = CalendarWeek;

  channel.reply('calendar', function() {
    return Calendar;
  });

  channel.reply('calendar-week', function() {
    return CalendarWeek;
  });

  module.exports = Calendar;
});

